import { render, staticRenderFns } from "./UpdatePlayer.vue?vue&type=template&id=df0841bc&lang=html&"
import script from "./UpdatePlayer.vue?vue&type=script&lang=js&"
export * from "./UpdatePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports